<template>
  <div>
    <draggable v-model="propertiesData" :options="{handle: '.draggable__handle'}">
      <app-editable-property
        v-for="(prop, index) in propertiesData"
        :key="`editable-prop-${prop.id}`"
        :index="index"
        :property="prop"
        :config-type="configType"
        @change="updateProp(index, $event)"
        @remove="removeProp(index)"
      ></app-editable-property>
    </draggable>

    <a-button type="primary" @click="addNewProp">Add property</a-button>
  </div>
</template>

<script>
import AppEditableProperty from "./EditableProp";
import draggable from "vuedraggable";

export default {
  props: {
    properties: {
      type: Array
    },
    configType: {
      type: String
    }
  },
  data() {
    return {
      // drag: false,
      propertiesData: this.properties,
      newProp: {
        type: null,
        label: null,
        attributes: {}
      }
    };
  },
  watch: {
    propertiesData() {
      this.$emit("apply", this.propertiesData);
    }
  },
  methods: {
    updateProp(index, eventData) {
      this.$set(this.propertiesData, index, eventData);
      this.$emit("apply", this.propertiesData);
    },
    removeProp(index) {
      this.$delete(this.propertiesData, index);
    },
    addNewProp() {
      let prop = _.cloneDeep(this.newProp);
      prop.id = this.randomString();
      this.propertiesData.push(prop);
    }
  },
  components: {
    AppEditableProperty,
    draggable
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  display: flex;
}
</style>

